import { ChangeEvent, useState } from "react";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Col, Form } from "reactstrap";
import { Previous, StudentValidationFormTitle } from "../../../../../../constants";
import { StudentValidationFormSubTitle } from "../../../../../../data/formsAndTable/forms/FormLayout";
import FinishForm from "../../common/FinishForm";
import { useForm } from "react-hook-form";
import { StudentForm } from "../../../../../../types/Forms";
import BasicInfoForm from "./BasicInfoForm";
import ProfileForm from "./ProfileForm";
import SocialLinksForm from "./SocialLinksForm";
import CommonCardHeader from "../../../../../../coreComponents/CommonCardHeader";

const StudentValidationForm = () => {
  const [step, setStep] = useState(1);
  const [showSubmit, setShowSubmit] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const {
    register,
    formState: { errors },
    setValue,
    watch,
    trigger,
  } = useForm<StudentForm>({});

  const formData = watch(); // Store watched values so that they persist between steps

  const handleSubmitButton = () => toast.success("Successfully Completed");
  const updateFormData = (event: ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    let value: string | boolean | File = "";
    if (event.target.type === "checkbox") {
      value = event.target.checked;
    } else if (event.target.type === "file") {
      value = event.target.files?.[0] || "";
    } else {
      value = event.target.value || "";
    }
    if (name === "imageUpload") {
      const file = value as File;
      if (file instanceof File) {
        const reader = new FileReader();
        reader.onload = () => {
          setSelectedImage(reader.result as string);
        };
        reader.readAsDataURL(file);
      }
    }
    setValue(name as keyof StudentForm, value as string, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const handleNextButton = async () => {
    let fieldsToValidate: (keyof StudentForm)[] = [];
    if (step === 1) {
      fieldsToValidate = ["name", "email", "password", "confirmPassWord"];
    } else if (step === 2) {
      fieldsToValidate = ["projectDescription", "portfolioURL", "imageUpload"];
    } else if (step === 3) {
      fieldsToValidate = ["twitterUrl", "gitHubUrl", "studentFile", "positions", "positionQuestion"];
    }
    const isValid = await trigger(fieldsToValidate); //Use trigger to validate only the fields for the current step instead of the entire form.
    if (isValid) {
      setStep((prevStep) => prevStep + 1);
      if (step === 3) setShowSubmit(true);
    } else {
      toast.error("Please fill out all the fields before moving on to the next step");
    }
  };

  const handleBackButton = () => {
    setShowSubmit(false);
    setStep((prev) => prev - 1);
  };
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={StudentValidationFormTitle} span={StudentValidationFormSubTitle} />
        <CardBody className="custom-input">
          <Form className="form-wizard" onSubmit={(e) => e.preventDefault()}>
            <div className={`tab ${step === 1 ? "d-block" : "d-none"}`}>
              <BasicInfoForm register={register} errors={errors} formData={formData} updateFormData={updateFormData} />
            </div>
            <div className={`tab ${step === 2 ? "d-block" : "d-none"}`}>
              <ProfileForm register={register} errors={errors} formData={formData} updateFormData={updateFormData} selectedImage={selectedImage} />
            </div>
            <div className={`tab ${step === 3 ? "d-block" : "d-none"}`}>
              <SocialLinksForm register={register} errors={errors} formData={formData} updateFormData={updateFormData} />
            </div>
            {step === 4 && <FinishForm />}
            <div className="text-end pt-3">
              {step > 1 && (
                <Button color="secondary" className="me-1" onClick={handleBackButton}>
                  {Previous}
                </Button>
              )}
              <Button color="primary" onClick={showSubmit ? handleSubmitButton : handleNextButton}>
                {showSubmit ? "Submit" : "Next"}
              </Button>
            </div>
            <div className="text-center">
              <span className={`step ${step === 1 ? "active" : ""}`} />
              <span className={`step ${step === 2 ? "active" : ""}`} />
              <span className={`step ${step === 3 ? "active" : ""}`} />
              <span className={`step ${step === 4 ? "active" : ""}`} />
            </div>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default StudentValidationForm;
